var map = {
	"./img/cards.png": "84a2",
	"./img/ui/biome-frame.png": "0ba4",
	"./img/ui/card-back.png": "e55c",
	"./img/ui/card-bg-deco-no-value-dark.png": "6fb5",
	"./img/ui/card-bg-deco-no-value.png": "b64a",
	"./img/ui/card-bg-deco.png": "7230",
	"./img/ui/card-bg.png": "4db3",
	"./img/ui/card-frame-brown.png": "1742",
	"./img/ui/card-frame-gray.png": "641e",
	"./img/ui/card-frame-orange.png": "291a",
	"./img/ui/card-frame-purple.png": "c209",
	"./img/ui/card-frame-red.png": "3190",
	"./img/ui/card-frame-yellow.png": "f161",
	"./img/ui/chest-frame.png": "48a3",
	"./img/ui/click.png": "001e",
	"./img/ui/grab.png": "8c6f",
	"./img/ui/hand.png": "1f3d",
	"./img/ui/heart.png": "8662",
	"./img/ui/hero-frame.png": "f057",
	"./img/ui/hit01.png": "8ef0",
	"./img/ui/icons.png": "7d58",
	"./img/ui/light-frame.png": "a38b",
	"./img/ui/monster-attack-emote.png": "a4d3",
	"./img/ui/pointer.png": "6bf8",
	"./img/ui/shards01.png": "25a5",
	"./img/ui/shield.png": "d564"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e31b";